import { generate } from '../../../core/js/utils/componentUtils';

export function init(store, overrides = {}) {
    const config = {
        name: 'sliderComponent'
    };

    return generate(config, store, overrides);
}
